import React from 'react';

import { SocialAccount } from '../types/api';

interface IgAccountOptionsProps {
  account: SocialAccount;
  /** True when this account is currently selected for the post. */
  selected: boolean;
  /** Number of selected Instagram accounts. The Collaborator toggle only
   *  appears when there's more than one — a collaborator needs another IG
   *  account to be the primary feed poster. */
  igSelectedCount: number;
  isCollaborator: boolean;
  isStory: boolean;
  onToggleCollaborator: () => void;
  onToggleStory: () => void;
}

/** Per-account Instagram Collaborator / Story toggles, shown under a
 *  selected Instagram account row. Shared by the wizard accounts step,
 *  the post form, and the dashboard repost modal so all three surface the
 *  same Instagram options instead of forking the markup. */
export default function IgAccountOptions({
  account, selected, igSelectedCount,
  isCollaborator, isStory, onToggleCollaborator, onToggleStory,
}: IgAccountOptionsProps): React.ReactElement | null {
  if (account.platform !== 'instagram' || !selected) return null;
  return (
    <div className="ig-account-options">
      {igSelectedCount > 1 && (
        <label className="ig-account-option">
          <input type="checkbox" checked={isCollaborator} onChange={onToggleCollaborator} />
          Collaborator
        </label>
      )}
      <label className="ig-account-option">
        <input type="checkbox" checked={isStory} onChange={onToggleStory} />
        Story
      </label>
      {isCollaborator && (
        <small className="muted">
          invited on the primary account&apos;s post — no separate feed post
          {isStory ? '; Story still posts here' : ''}
        </small>
      )}
    </div>
  );
}
